import styled, { css, keyframes } from 'styled-components';
import { Button, Label } from '../../../Components/uielements';
import { key, palette } from 'styled-theme';
import { media } from '../../../helper/styleHelper';

export const BroadcastHeaderContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`;

export const BroadcastContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  padding-top: 10px;
  ${media.xl`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

export const BroadcastContainerLeft = styled.div`
  display: grid;
  height: fit-content;
  gap: 15px;
`;
export const BroadcastContainerRight = styled.div`
  display: grid;
  justify-self: flex-end;
  height: fit-content;
`;

export const InputWrapper = styled.div`
  display: grid;
  gap: 14px;
`;

export const LabelTitle = styled(Label)`
  font-size: 16px;
  font-weight: 500;

  ${media.xxl`
   font-size: 18px;
  `}
`;
export const HeaderTitle = styled.p`
  font-family: Space Grotesk Regular;
  font-size: ${key('sizes.vxxlFont.normal', '20px')} !important;
  font-weight: bold;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 5px;
  text-transform: uppercase;
  color: ${palette('text', 4)};
  ${({ isRed }) =>
    isRed
      ? css`
          color: ${palette('error', 0)};
        `
      : css`
          color: ${palette('text', 4)};
        `}
`;

export const ContentWrapper = styled.div`
  margin: auto;
  padding: 30px 20px;
  min-width: 400px;
  display: grid;
  gap: 10px;
`;
export const MessageTitle = styled.p`
  display: grid;
  justify-content: center;
  align-items: center;
  justify-items: center;
  margin-top: 5%;
  font-size: larger;
  gap: 20px;
  font-size: 16px;
  font-family: Space Grotesk Regular;
  color: ${palette('text', 1)};
`;

export const BroadCastButton = styled(Button)`
  color: #fff;
`;

export const EmergencyButton = styled(Button)`
  background-color: ${palette('error', 0)};
  border: none;
  color: ${palette('text', 1)};
  &:hover {
    border-color: ${palette('error', 0)};
    color: red;
    border: 1px solid red;
  }
`;

const slideDown = keyframes`
  from {
    opacity: 0;
    max-height: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    max-height: 400px;
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateX(-4px); }
  to   { opacity: 1; transform: translateX(0); }
`;

export const GroupRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const GroupMemberPanel = styled.div`
  margin-left: 32px;
  padding: 10px 14px;
  border-left: 2px solid ${palette('border', 0)};
  border-radius: 0 6px 6px 0;
  background: ${palette('background', 0)};
  overflow: hidden;
  animation: ${slideDown} 0.25s ease forwards;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MemberRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  animation: ${fadeIn} 0.2s ease forwards;
  animation-delay: ${({ index }) => index * 40}ms;
  opacity: 0;
`;

export const MemberAvatar = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${palette('background', 2)};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  flex-shrink: 0;
  text-transform: uppercase;
`;

export const MemberInfo = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.3;
`;

export const MemberEmail = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme?.textSecondary || '#888'};
`;

export const GroupHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ViewIconButton = styled.button`
  background: none;
  border: none;
  padding: 2px 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition:
    color 0.2s ease,
    transform 0.2s ease;
  border-radius: 4px;

  &:hover {
    transform: scale(1.15);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
